



































import { defineComponent, PropType } from '@vue/composition-api'
import { CatalogItem } from '@/store/socialStream/postApiRequestHelper'
import CatalogItemsLinkerStore from '@/store/catalogItemsLinker/catalogItemsLinker'
import { BImg } from 'bootstrap-vue'

export default defineComponent({
  name: 'PostRow',
  components: { BImg },
  props: {
    post: {
      type: Object as PropType<CatalogItem>,
      required: true,
    },
  },
  computed: {
    calculateHeight(): string {
      return '100%'
      const heightInPixels = Math.ceil((window.innerHeight - 200) / 8)
      return `${heightInPixels}px`
    },
    calculateMaxWidth(): string {
      console.log(window.innerWidth)
      const widthInPixels = Math.ceil((window.innerWidth) / 6)
      return `${widthInPixels}px`
    },
    assignedProductsCnt(): number {
      return (CatalogItemsLinkerStore.state.linkedIds as { [key: string]: any })[this.post.id] ? 
              (CatalogItemsLinkerStore.state.linkedIds as { [key: string]: any })[this.post.id].length : 0
    }
  },
  methods: {
    goToPostDetails(postId: string) {
      this.$router.push({ name: 'socialStreamPost', params: { postId, configId: this.$route.params.configId } })
    },
  },
})
